import { render, staticRenderFns } from "./UserDemoInfo.vue?vue&type=template&id=0bfcf879&scoped=true&"
import script from "./UserDemoInfo.vue?vue&type=script&lang=js&"
export * from "./UserDemoInfo.vue?vue&type=script&lang=js&"
import style0 from "./UserDemoInfo.vue?vue&type=style&index=0&id=0bfcf879&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfcf879",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
